import { type DealTrackingMetric } from "@vega-api/generated/types/dealTrackingMetric";
import { MetricCard } from "@vega-core/components/MetricCard/MetricCard";

import {
  getMetricDisplayValue,
  METRIC_CARD_LOADING_PLACEHOLDERS,
} from "../../utils/dealTrackingMetricDisplay";

type DealTrackingAnalyticsCardsProps = {
  metrics: DealTrackingMetric[];
  isLoading?: boolean;
};

export const DealTrackingAnalyticsCards = ({
  metrics,
  isLoading,
}: DealTrackingAnalyticsCardsProps) => {
  if (!isLoading && metrics.length === 0) return null;

  return (
    <div
      className="grid grid-cols-2 xl:grid-cols-4 gap-4"
      data-testid="deal-tracking-analytics-cards"
    >
      {isLoading
        ? METRIC_CARD_LOADING_PLACEHOLDERS.map((id) => (
            <MetricCard
              dataTestId={`tracking-metric-loading-${id}`}
              isLoading
              key={id}
              title=""
              value=""
            />
          ))
        : metrics.map((metric) => (
            <MetricCard
              dataTestId={`tracking-metric-${metric.label}`}
              key={metric.label}
              title={metric.label}
              value={getMetricDisplayValue(metric)}
            />
          ))}
    </div>
  );
};
